import { z } from 'zod';

export type Severity = z.infer<typeof Severity>;

export const Severity = z.enum(['critical', 'warning', 'offline', 'ok']);
